import React from 'react'
import { Link } from 'react-router-dom'

const NavBar = () => {
  return (
    <div>
      <header style={{ display: 'flex', justifyContent: 'space-around' }}>
        <Link to='/'>MAIN</Link>
        <Link to='/search-data'>PATHWAY SEARCH</Link>
        <Link to='/associated-papers'>ASSOCIATED PAPERS</Link>
      </header>
      <hr/>
    </div>  
  )
}

export default NavBar